import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { ArticleSection } from './ArticleSection';
import { ExternalLink } from '../ExternalLink';
import { contextualLinks } from '../../data/site';
const controls = ['Data minimisation: only send models the fields a task actually needs.', 'Role-based access and least-privilege credentials for every integration.', 'Complete audit logs of inputs, outputs, decisions and approvals.', 'Pre-launch and ongoing evaluation of accuracy, bias and failure modes.', 'Human oversight for decisions with legal or similarly significant effects.', 'Data processing agreements covering vendors and model providers.', 'An incident process for pausing, rolling back and reporting issues.'];
export function GovernanceSection() {
  const link = contextualLinks.governanceUsa;
  return <ArticleSection id="governance" title="AI Governance, Security and Compliance" data-id="element-89" data-mp="23yoi6kdvmj3w">
      <p data-id="element-90" data-mp="1zy4jhcdnn7fn">
        In England, AI workflows that process personal data fall under UK GDPR and the Data Protection Act
        2018, and the Information Commissioner’s Office publishes guidance on AI and data protection.
        Organisations with EU customers or operations also need to consider the EU AI Act, which
        introduces risk-based obligations for certain AI systems and is being phased in over several years.
      </p>
      <p data-id="element-91" data-mp="rjfvc2udsjtv">
        Governance should not be a document that sits beside the workflow. It needs to be built into it.
        In practice, that means:
      </p>
      <div className="glass rounded-2xl p-5 md:p-6" data-id="element-92" data-mp="10l5y24tpr56y">
        <p className="flex items-center gap-2 !text-base font-semibold !text-ink" data-id="element-93" data-mp="15d74vb8443pl">
          <ShieldCheckIcon className="h-5 w-5 text-aurora-cyan" aria-hidden="true" data-id="element-94" data-mp="15fjl9jy8260j" />
          Controls to expect from any provider
        </p>
        <ul className="bullets mt-4" data-id="element-95" data-mp="1fc66i9ugmz33">
          {controls.map(control => <li key={control} className="!text-[0.975rem]" data-id="element-96" data-mp="1ka7yjk9v68qp">{control}</li>)}
        </ul>
      </div>
      <p data-id="element-97" data-mp="ulsu72if2r8t">
        For organisations operating across the Atlantic, reviewing{' '}
        <ExternalLink href={link.href} data-id="element-98" data-mp="pn920kd8cj80">{link.anchor}</ExternalLink> can help align internal policies so the
        same workflow meets expectations in both markets.
      </p>
    </ArticleSection>;
}